import { render, staticRenderFns } from "./Description_mobile.vue?vue&type=template&id=dae0777a&scoped=true&"
import script from "./Description_mobile.vue?vue&type=script&lang=js&"
export * from "./Description_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Description_mobile.vue?vue&type=style&index=0&id=dae0777a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae0777a",
  null
  
)

export default component.exports